import { SavedSearch } from '~/contracts/common';
import Chevron from '~/icons/Chevron';

type OwnProps = {
  links: SavedSearch[];
};

//TODO need to update the place holder text in this file when platform team provides the data
export default function SavedSearchLink({ links }: OwnProps) {
  return links.map(link => {
    const { name, savedSearchId, url } = link;

    return (
      <div
        key={savedSearchId}
        className="py-2xl first:pt-0 last:pb-0"
        data-qa="saved-search-links"
      >
        <a
          href={`/cars/filters?cvnaid=${url}`}
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: 'Search Card',
            type: 'saved',
            item: 'search'
          })}
          className="grid grid-cols-[1fr_16px] items-center gap-xl text-blue-6"
        >
          <div className="flex flex-col gap-8 overflow-hidden">
            <div className="truncate tl-header-s" title={name}>
              {name}
            </div>
            <div className="flex items-center gap-8">
              <p className="tl-body-s">place holder results</p>
              <div className=" py-2 h-fit flex-shrink-0 rounded-full bg-marketplace-purple px-8  text-xs font-bold leading-4 text-gray-500 text-white">
                PH New
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <Chevron />
          </div>
        </a>
      </div>
    );
  });
}
